import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import loanFormModel from '../../form_models/loanFormModel';
import { Rule } from '../../interfaces/Rule';

const { primaryMotivationForSolar, projectType } = loanFormModel.formField;

export class IsProjectTypeSolar implements Rule {
  public evaluate(data: Partial<ApplicationFormValues>): boolean {
    const projectTypeNormalized = data[projectType.name]?.toLowerCase() ?? '';

    return primaryMotivationForSolar.allowedProjectTypes.includes(
      projectTypeNormalized
    );
  }
}

export default new IsProjectTypeSolar();
